module.exports = __webpack_public_path__ + "static/media/wmsui32_5901.5a56dfd7.ico";